"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tariffs = exports.SendMails = exports.MonetaryAmountFieldset = exports.InvoiceClaimsDashboard = exports.ExchangeRateFieldset = exports.Claims = void 0;
const Claims_yaml_component_1 = __importDefault(require("./Claims.yaml?component"));
exports.Claims = Claims_yaml_component_1.default;
const ExchangeRateFieldset_yaml_component_1 = __importDefault(require("./ExchangeRateFieldset.yaml?component"));
exports.ExchangeRateFieldset = ExchangeRateFieldset_yaml_component_1.default;
const InvoiceClaimsDashboard_yaml_component_1 = __importDefault(require("./InvoiceClaimsDashboard.yaml?component"));
exports.InvoiceClaimsDashboard = InvoiceClaimsDashboard_yaml_component_1.default;
const MonetaryAmountFieldset_yaml_component_1 = __importDefault(require("./MonetaryAmountFieldset.yaml?component"));
exports.MonetaryAmountFieldset = MonetaryAmountFieldset_yaml_component_1.default;
const SendMails_yaml_component_1 = __importDefault(require("./SendMails.yaml?component"));
exports.SendMails = SendMails_yaml_component_1.default;
const Tariffs_yaml_component_1 = __importDefault(require("./Tariffs.yaml?component"));
exports.Tariffs = Tariffs_yaml_component_1.default;
__exportStar(require("./dunning-letter"), exports);
__exportStar(require("./primitives"), exports);
